import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../core/feature/config/configSlice";
import { useLocation } from "react-router-dom";
import * as API from "../core/service/api";
import { setUser } from "../core/feature/user/userSlice";
import { setToken } from "../core/feature/token/tokenSlice";
import { setCompany } from "../core/feature/company/companySlice";

const SecureRedirect = () => {
  const dispatch = useDispatch();

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let userType = query.get("userType");
  let state = query.get("state");
  let tokenurl = query.get("token");
  let id: any = query.get("checkoutId");

  const cekToken = async () => {
    dispatch(setLoading(true));
    const datapost = {
      state: state,
      token: tokenurl,
      userType: userType,
    };
    await API.secureRedirect(datapost)
      .then((res) => {
        const data: any = res.data.data;
        getCompanyInitial(data.companyInitial);
        dispatch(setToken(data.authToken));
        dispatch(setUser(data));
        // dispatch(setUserLogin(userLogin));
        dispatch(setLoading(false));
        redirect(`/${id}`);
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };

  const getCompanyInitial = async (init: any) => {
    await API.getCompany(init)
      .then((res) => {
        dispatch(setCompany(res.data.data));
      })
      .catch((err) => { });
  };

  const redirect = (res: any) => {
    document.location.href = `${res}`;
  };

  useEffect(() => {
    cekToken();
  }, []);

  return <div></div>;
};

export default SecureRedirect;
